export default {
  SEND_MESSAGE: 'sendMessage',
  GET_CHAT_HISTORY: 'getChatHistory',
  GET_USER_SESSIONS: 'getUserSessions',
  REMOVE_USER_SESSION: 'removeUserSession',
  RENAME_USER_SESSION: 'renameUserSession',
  GENERATE_USER_SESSION_TITLE: 'generateUserSessionTitle',
}
